import styled from "styled-components";

const LinkList = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
`;

const ListItem = styled.li`
  margin-right: 1em;
`;

export { LinkList, ListItem };



// WEBPACK FOOTER //
// ./src/components/LinkList/index.js